import styled from '@emotion/styled';
import { blue, green, purple, red, yellow } from '@styles/Colors';
import { PostsCategoryResponse } from 'models/swagger-spring/data-contracts';
import { useTranslation } from 'next-i18next';

type Props = {
  readonly category: PostsCategoryResponse;
};

type BlogCategoryTagColor = {
  color: string;
  backgroundColor: string;
};

const Badge = styled.span<BlogCategoryTagColor>`
  display: flex;
  padding: 2px 10px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 4px;
  background: ${(props) => props.backgroundColor};

  color: ${(props) => props.color};
  text-align: center;

  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.28px;
`;

export default function BlogCategoryBadge({ category }: Props) {
  return (
    category && (
      <Badge color={category.color} backgroundColor={category.backgroundColor}>
        {category.name}
      </Badge>
    )
  );
}
